import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {usePrevious} from "@pg-mono/hooks";
import {isEqual} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../maps/actions/fetch_osm_pois_routes_grouped";
import {getRoutes} from "../../maps/api/get_routes";
import {IPoiAround} from "../../maps/types/IPoiAround";
import {fetchSingleRegionSimple} from "../../search/actions/fetch_search_regions_action";
import {offerListNumlabsCacheDayTime} from "../constants/offer_list_numlabs_cache_day_time";

export function useOfferListMapTransportRoutes() {
    const selectedRegions = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);
    const regionIds = selectedRegions.map((region) => region.id);
    const [transportRoutes, setTransportRoutes] = useState<IOSMPoisRoutesGrouped[] | null>(null);
    const [requestState, setRequestState] = useState(RequestState.None);
    const previousRegionIds = usePrevious(regionIds, regionIds);

    const hasRegions = regionIds && regionIds.length > 0;

    const fetchTransportRoutes = async () => {
        setRequestState(RequestState.Waiting);

        try {
            const transportRoutes = await getTransportRoutes(regionIds);

            setRequestState(RequestState.Success);
            setTransportRoutes(transportRoutes);
        } catch {
            setRequestState(RequestState.Error);
        }
    };

    useEffect(() => {
        if (hasRegions && requestState === RequestState.None) {
            fetchTransportRoutes();
        }
    }, [requestState]);

    useEffect(() => {
        if (previousRegionIds.length > 0 && regionIds.length === 0) {
            setTransportRoutes(null);
        }
        const regionsChanged = !isEqual(previousRegionIds, regionIds);

        if (hasRegions && regionsChanged) {
            fetchTransportRoutes();
        }
    }, [regionIds]);

    return {
        transportRoutes,
        requestState
    };
}

async function getTransportRoutes(regionIds: number[]) {
    const regionsDetails = await Promise.all(regionIds.map((regionId) => fetchSingleRegionSimple(regionId)));

    const regionAreas: IPoiAround[] = regionsDetails.map((region) => ({
        latitude: region.area.center.lat,
        longitude: region.area.center.lon,
        radius: region.area.radius
    }));

    const promises = await Promise.all(regionAreas.map((area) => getRoutes(area, offerListNumlabsCacheDayTime)));
    return promises.filter(Boolean) as IOSMPoisRoutesGrouped[];
}
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {usePrevious} from "@pg-mono/hooks";
import {isEqual} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../maps/actions/fetch_osm_pois_routes_grouped";
import {getRoutes} from "../../maps/api/get_routes";
import {IPoiAround} from "../../maps/types/IPoiAround";
import {fetchSingleRegionSimple} from "../../search/actions/fetch_search_regions_action";
import {offerListNumlabsCacheDayTime} from "../constants/offer_list_numlabs_cache_day_time";

export function useOfferListMapTransportRoutes() {
    const selectedRegions = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);
    const regionIds = selectedRegions.map((region) => region.id);
    const [transportRoutes, setTransportRoutes] = useState<IOSMPoisRoutesGrouped[] | null>(null);
    const [requestState, setRequestState] = useState(RequestState.None);
    const previousRegionIds = usePrevious(regionIds, regionIds);

    const hasRegions = regionIds && regionIds.length > 0;

    const fetchTransportRoutes = async () => {
        setRequestState(RequestState.Waiting);

        try {
            const transportRoutes = await getTransportRoutes(regionIds);

            setRequestState(RequestState.Success);
            setTransportRoutes(transportRoutes);
        } catch {
            setRequestState(RequestState.Error);
        }
    };

    useEffect(() => {
        if (hasRegions && requestState === RequestState.None) {
            fetchTransportRoutes();
        }
    }, [requestState]);

    useEffect(() => {
        if (previousRegionIds.length > 0 && regionIds.length === 0) {
            setTransportRoutes(null);
        }
        const regionsChanged = !isEqual(previousRegionIds, regionIds);

        if (hasRegions && regionsChanged) {
            fetchTransportRoutes();
        }
    }, [regionIds]);

    return {
        transportRoutes,
        requestState
    };
}

async function getTransportRoutes(regionIds: number[]) {
    const regionsDetails = await Promise.all(regionIds.map((regionId) => fetchSingleRegionSimple(regionId)));

    const regionAreas: IPoiAround[] = regionsDetails.map((region) => ({
        latitude: region.area.center.lat,
        longitude: region.area.center.lon,
        radius: region.area.radius
    }));

    const promises = await Promise.all(regionAreas.map((area) => getRoutes(area, offerListNumlabsCacheDayTime)));
    return promises.filter(Boolean) as IOSMPoisRoutesGrouped[];
}
